(function ($) {
	$(function () {
		$(".ex-select2").select2({

		});

		$(".main-member-form").on("submit", function (e) {
			e.preventDefault();

			let $form	=	$(this);
			let url		=	WKTValues.themeURL;

			$form.addClass("ex-loading");
			$form.find(".ex-error").empty();
			$form.find(".ex-message").hide();

			$.ajax({
				url			:	url +"/ajax.php",
				method		:	"post",
				data		:	$form.serialize(),
				dataType	:	"json",
				timeout		:	300 * 1000,
			}).done(function (results) {
				if(results.code == "200") {
					$form.find(".ex-success").fadeIn();

					if(results.data.redirect) {
						location.href	=	WKTValues.homeURL + results.data.redirect;
					}
				}
				else if(results.code == "302") {
					location.href	=	WKCPValues.homeURL +"/login"
				}
				else if(results.code == "419") {
					$form.find(".ex-message.ex-error").text(results.message).stop().fadeIn();
				}
				else {
					for(let key in results.errors) {
						$form.find(".ex-error[data-name="+ Common.escapeSelector(key) +"]").text(results.errors[key]);

						$form.find(".ex-message.ex-error").text("エラーがあります").stop().fadeIn();
					}
					
					if($form.find(".ex-error[data-name]:not(:empty):first").length != 0) {
						$("html, body").animate({scrollTop: $form.find(".ex-error[data-name]:not(:empty):first").closest(".ex-element").position().top});
					}
				}
			}).fail(function (xhr, status, error) {
				$form.find(".ex-error").text("エラーがあります").stop().fadeIn();
			}).always(function () {
				$form.removeClass("ex-loading");
			});
		});

		$(".main-member-contact-details-form-control-attachment").on("change", "input[type=file]", function () {
			let $target		=	$(this);

			if($target.get(0).files[0] && $target.get(0).files[0].name) {
				$(".main-member-contact-details-form-control-attachment-filename").text($target.get(0).files[0].name);
				$(".main-member-contact-details-form-control-attachment-remove").show();
			}
			else {
				$(".main-member-contact-details-form-control-attachment-filename").text("");
				$(".main-member-contact-details-form-control-attachment-remove").hide();
			}

		}).find("input[type=file]").trigger("change");

		$(".main-member-contact-details-form-control-attachment-remove").on("click", function () {
			$(".main-member-contact-details-form-control-attachment input[type=file]").replaceWith($(".main-member-contact-details-form-control-attachment input[type=file]").get(0).outerHTML);
			$(".main-member-contact-details-form-control-attachment-remove").hide();
			
			$(".main-member-contact-details-form-control-attachment").find("input[type=file]").trigger("change");
		});

		//受信者絞り込み
		$(".main-member-contacts-company select").on("change", function () {
			let $target	=	$(this);

			if($target.val() != "") {
				location.href	=	"/member/contact/company/"+ $target.val();
			}
			else {
				location.href	=	"/member/contact/";
			}
		});

		//メッセージ送信
		$(".main-member-contact-details-form").on("submit", function (e) {
			e.preventDefault();

			let $form	=	$(this);
			let url		=	WKTValues.themeURL;

			$form.addClass("ex-loading");
			$form.find(".ex-error").empty();
			$form.find(".ex-message").hide();

			$.ajax({
				url			:	url +"/ajax.php",
				method		:	"post",
				data		:	new FormData($form.get(0)),
				dataType	:	"json",
				cache		:	false,
				contentType	:	false,
				processData	:	false,
				timeout		:	300 * 1000,
			}).done(function (results) {
				if(results.code == "200") {
					$form.find(".ex-success").fadeIn();

					$(".main-member-contact-details-form").before(results.data.html);
					$form.get(0).reset();
					$(".main-member-contact-details-form-control-attachment").find("input[type=file]").trigger("change");
				}
				else if(results.code == "302") {
					location.href	=	WKCPValues.homeURL +"/login"
				}
				else if(results.code == "419") {
					$form.find(".ex-message.ex-error").text(results.message).stop().fadeIn();
				}
				else {
					for(let key in results.errors) {
						$form.find(".ex-error[data-name="+ Common.escapeSelector(key) +"]").text(results.errors[key]);
					}
				}
			}).fail(function (xhr, status, error) {
				$form.find(".ex-error.ex-message").text("Erreur de communication").stop().fadeIn();
			}).always(function () {
				$form.removeClass("ex-loading");
			});
		});
	});
})(jQuery);